// This component contains all the logic of side menu navigation and highlight.
// It is tightly coupled with the sideMenuModel

import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import "./sideMenu.scss";
import HomeIcon from "@material-ui/icons/Home";
import c2cIcon from "../../../../assets/sideMenu/c2cIcon.svg";
import c2cActiveIcon from "../../../../assets/sideMenu/c2cActiveIcon.svg";
import {
  sideMenuRenderList,
  SIDE_MENU_PATHS,
  SIDE_MENU_IMAGES,
  SIDE_MENU_SELECTED_IMAGES,
  TITLES,
} from "./model/sideMenuModel";
import { newMedUpdatesURL, pemUrl } from "../../../../Util/API Calls/APIList";
import { useCookies } from "react-cookie";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import DoctorContext from "../../../ClinicComponents/ClinicWrapper/DoctorContext";

export const CLINIC_URL_TYPE = {
  CLINIC: "clinic",
  DOCTOR: "doctor",
};

const SideMenu = ({ user_type, clinic_url_type, rightUI }) => {
  let location = useLocation();
  const history = useHistory();
  const doctorContext = useContext(DoctorContext);
  const [showRightView, setShowRightView] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [enableLeadsDashboard, setEnableLeadsDashboard] = useState(false);
  const [cookies, setCookie] = useCookies(["cookie-name"]);
  const [disableHover, setDisableHover] = useState(false);
  let is_partial_doctor =
    localStorage.getItem("is_partial_doctor") &&
    localStorage.getItem("is_partial_doctor") === "True"
      ? true
      : false;

  useEffect(() => {
    setEnableLeadsDashboard(doctorContext?.enableLeadsDashboard);
  }, [doctorContext?.enableLeadsDashboard]);

  // Helper methods ==>
  const isHighlightSideMenu = (data) => {
    // let currentLocationPath = location?.pathname?.indexOf(data.path) > -1;
    let checkPath = location?.pathname.split("/");
    let currentLocationPath = checkPath?.includes(data.path);
    // return activeIndex === data.display_order || currentLocationPath;
    return currentLocationPath;
  };

  const createURL = (path) => {
    switch (path) {
      case SIDE_MENU_PATHS.HELPANDSUPPORT:
        return `/${path}`;
      // case SIDE_MENU_PATHS.C2CMEDUPDATES:
      //   return `/${clinic_url_type}`
      default:
        return `/${clinic_url_type}/account/${path}`;
    }
  };

  const clickOnMenu = (data) => {
    setDisableHover(true);
    setShowRightView(false);
    setActiveIndex(data.id);
    if (data.path === SIDE_MENU_PATHS.PATIENTEDUCATION) {
      window.location.replace(
        `${pemUrl}/${clinic_url_type}/account/patienteducation`
      );
    }
    if (data.path === SIDE_MENU_PATHS.C2CMEDUPDATES) {
      window.location.replace(`${newMedUpdatesURL}${clinic_url_type}`);
    }
    setTimeout(() => {
      setDisableHover(false);
    }, 500);
  };
  // <==

  // create UI ==>
  const sideMenulistForPartialDoctor = (data) => {
    return (
      <li className="disable" key={data.id}>
        <div className="link partial-doctor">
          <img className="toggle-img" src={data.icon} alt="icon" />
          <span>{data.title}</span>
        </div>
      </li>
    );
  };

  const sideMenuListForUser = (data) => {
    const highlightSideMenu = isHighlightSideMenu(data);
    return (
      <li
        className={highlightSideMenu ? "active-index" : "toggle-active"}
        key={data.id}
      >
        <Link
          className="link"
          to={createURL(data.path)}
          onClick={() => clickOnMenu(data)}
        >
          <img
            className={highlightSideMenu ? "hide" : "toggle-img"}
            src={data.icon}
            alt="icon"
          />
          <img
            className="toggle-active-img"
            src={data.selected_icon}
            alt="icon"
          />
          <span>{data.title}</span>
        </Link>
      </li>
    );
  };

  const createLogoutButton = () => {
    let highlightSideMenu =
      location?.pathname?.indexOf(SIDE_MENU_PATHS.LOGOUT) > -1;
    return (
      <div className="head-nav">
        <hr />
        <li className={highlightSideMenu ? "active-index" : "toggle-active"}>
          <Link className="link" to={`/${SIDE_MENU_PATHS.LOGOUT}`}>
            <img
              className={highlightSideMenu ? "hide" : "toggle-img"}
              src={SIDE_MENU_IMAGES.LOGOUT_IMAGE}
              alt="icon"
            />
            <img
              className="toggle-active-img"
              src={SIDE_MENU_SELECTED_IMAGES.LOGOUT_SELECTED_IMAGE}
              alt="icon"
            />
            <span>{TITLES.LOGOUT}</span>
          </Link>
        </li>
      </div>
    );
  };

  const createSideMenuListRow = (data) => {
    if (is_partial_doctor && data.disabled_for_partial_doctor) {
      return sideMenulistForPartialDoctor(data);
    } else {
      return sideMenuListForUser(data);
    }
  };

  const createSideMenuListView = () => {
    return sideMenuRenderList(user_type, setCookie, enableLeadsDashboard).map(
      (data) => createSideMenuListRow(data)
    );
  };

  const mobileHeaderView = () => {
    return (
      <div className="side-menu-header" style={{ backgroundColor: "#fff" }}>
        <a href="#">
          <img src="/images/HN_logo.png" className="header-img " alt="logo" />
        </a>
        <div>
          <div className="d-md-none d-lg-none">
            <div className="home-btn-style d-flex">
              <div
                onClick={() => {
                  history.push("/");
                }}
              >
                <HomeIcon
                  className="doctor-info-home-icon"
                  style={{ fontSize: 30 }}
                />
              </div>
            </div>
          </div>
          <div
            className={`ham-menu js-ham-menu dashboard-mobile previous-patients-mobile messages-ride-mobile accounts-mobile my-schedule-fees-mobile  
      ${showRightView && "active"}`}
            onClick={() => setShowRightView(!showRightView)}
          >
            <span className="ham-menu__line"></span>
            <span className="ham-menu__line"></span>
            <span className="ham-menu__line"></span>
          </div>
        </div>
      </div>
    );
  };

  const leftContainerUI = () => {
    return (
      <header
        className={`${showRightView ? "side-menu-open" : ""} main-head ${
          disableHover && "main-head-disable-hover"
        }`}
      >
        <div>
          <img className="title-icon" src={c2cIcon} alt="icon" />
          <img className="title-active-icon" src={c2cActiveIcon} alt="icon" />
        </div>
        <nav className="head-nav">
          <ul>{createSideMenuListView()}</ul>
        </nav>
        {createLogoutButton()}
      </header>
    );
  };

  const rightContainerUI = () => {
    return (
      <div className="wrap-all-the-things">
        {mobileHeaderView()}
        {rightUI()}
      </div>
    );
  };
  // <==
  return (
    <div className="side-menu">
      {leftContainerUI()}
      {rightContainerUI()}
    </div>
  );
};

export default SideMenu;
